import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { createSearchParams, Link } from 'react-router-dom';
import { events } from 'services/analytics';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import useAnalytics from 'services/hooks/analytics';
import { locations } from 'services/routes/locations';

const UpgradeButton = () => {
  const { t } = useTranslation();
  const { track } = useAnalytics();

  const handleUpgradeClick = () => {
    track(
      events.upgradeSubscription(
        'distribution_banner',
        AnalyticsEventLocation.RELEASES
      )
    );
  };

  const query = createSearchParams({ distribution: 'true' });

  return (
    <Link
      to={{
        pathname: locations.subscription.pricing.pathname(''),
        search: query.toString(),
      }}
    >
      <Button onClick={handleUpgradeClick} variant="contained">
        {t('distribution:distributionInfoCta')}
      </Button>
    </Link>
  );
};

export default UpgradeButton;
